import { restClient } from '../config/restClient'

const endpoint = `/api/company/v2/member_profiles`

export const createMemberProfile = async data => {
  const response = await restClient(endpoint, {
    method: 'POST',
    data,
  })
  return response.data
}
